module.exports = __webpack_public_path__ + "img/az.2e1917c7.svg";